import React, {Component} from 'react';
import {connect} from 'react-redux';
import {addPopup, removePopup} from '../../redux/actions';
import './index.scss';

//popup types
import * as popups from '../../constants/popup-types';

//popup components
import BasicPopup from '../../components/popups/basic';
import NewsletterPopup from './custom/newsletter';
import AppPopup from './custom/app';
import BenefitLinkPopup from './custom/benefit_link';
import MembershipPopup from './custom/membership_popup';
import CardCheck from './custom/card_check';
import LoginPopup from './custom/new_login';
import RegistrationPhoneValidation from './custom/new_login/PhoneValidation';
import CopunFlow from './custom/coupon_flow';
import PaymentPopup from './custom/payment_popup';
import NewPaymentPopup from './custom/new_payment_popup';
import DeleteCard from './custom/delete_card';
import PhoneValidationPopup from './custom/phone_validation_popup';
import RadioOptions from './custom/radio-options';
import MapViewPopup from './custom/map_view_popup';
import PurchaseApproval from './custom/purchase_validation_popup';
import UploadFilePopup from './custom/upload_file_popup';
import AddAddress from "./custom/add_address";
import AddCreditCard from "./custom/add_credit_card";
import MembershipDownload from "./custom/membership_check_download_popup";
import CarLeadFormPopup from "./custom/car_lead_form_popup";
import TermsOfServicePopup from "./custom/lead_page_terms_of_service";
import VideoArticle from './custom/video_article';
import TravelInsurancePopup from './custom/travel_insurance_popup';
import WaiverAgreementPopup from "./custom/waiver_agreement";
import UsersConsentsPopup from './custom/data_sharing_popup';
import CreateForumPostPopup from './custom/create_forum_post_popup';
import ImagePopup from './custom/image_popup';
import SubsidyPopup from "./custom/subsidy_popup";
import DataSharingSubsidyPopup from "./custom/data_sharing_subsidy_popup";
import IframePopup from "./custom/iframe_popup";

class Popups extends Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    handleCloseClick = (popup) => {
        if (popup && popup.onClose && typeof popup.onClose === 'function') {
            popup.onClose();
        }
        this.props.removePopup();
    }

    handleSendAgain = (popup) => {
        if (popup && popup.sendAgainAction && typeof popup.sendAgainAction === 'function') {
            return popup.sendAgainAction();
        }
        return undefined;
    }

    getPopupComponent(popup) {
        const currentPopup = popup;
        switch (currentPopup.type) {

            case(popups.GENERAL_MESSAGE):
                return <BasicPopup key={currentPopup.key} popup_id={currentPopup.popup_id}
                                   text={currentPopup.text}
                                   handleClose={() => this.handleCloseClick(currentPopup)}
                                   backdropClick={() => this.handleCloseClick(currentPopup)}
                                   action={currentPopup.action}
                                   afterAction={currentPopup.afterAction}
                                   className={currentPopup.className}
                                   btnText={currentPopup.btnText}
                                   sendAgainText={currentPopup.sendAgainText}
                                   sendAgainAction={() => this.handleSendAgain(currentPopup)}
                                   afterSendAgainAction={currentPopup.afterSendAgainAction}/>
                break;
            case(popups.FILE_UPLOAD_POPUP):
                return <UploadFilePopup popup_id={currentPopup.popup_id} key={currentPopup.key}
                                        text={currentPopup.text}
                                        handleClose={this.handleCloseClick}
                                        backdropClick={this.handleCloseClick}
                                        payload={currentPopup.payload}/>
                break;

            case(popups.SUBSIDY_POPUP):
                return <SubsidyPopup popup_id={currentPopup.popup_id} key={currentPopup.key}
                                        header={currentPopup.header}
                                        content={currentPopup.content}
                                        contentType={currentPopup.contentType}
                                        benefits={currentPopup.benefits}
                                        handleClose={this.handleCloseClick}
                                        backdropClick={this.handleCloseClick}
                                        status={currentPopup.status}
                                        footerText={currentPopup.footerText}
                                        payload={currentPopup.payload}/>
                break;

            case(popups.API_MESSAGE):
                return <BasicPopup popup_id={currentPopup.popup_id} key={currentPopup.key}
                                   text={currentPopup.text}
                                   handleClose={this.handleCloseClick}
                                   backdropClick={this.handleCloseClick}/>
                break;
            case(popups.NEWSLETTER):
                return <NewsletterPopup text={currentPopup.text} key={currentPopup.key}
                                        handleClose={this.handleCloseClick}
                                        backdropClick={this.handleCloseClick}/>
                break;
            case(popups.APP_DOWNLOAD):
                return <AppPopup text={currentPopup.text} key={currentPopup.key}
                                 handleClose={this.handleCloseClick}
                                 backdropClick={this.handleCloseClick}/>
                break;
            case(popups.SEND_LINK):
                return <BenefitLinkPopup text={currentPopup.text} key={currentPopup.key}
                                         handleClose={this.handleCloseClick}
                                         backdropClick={this.handleCloseClick}
                                         benefitId={currentPopup.benefitId}/>
                break;
            case(popups.MEMBERSHIP_CHECK):
                return <MembershipPopup text={currentPopup.text} key={currentPopup.key}
                                        handleClose={this.handleCloseClick}
                                        backdropClick={this.handleCloseClick}
                                        benefitId={currentPopup.benefitId}/>
                break;
            case(popups.MEMBERSHIP_CHECK_DOWNLOAD):
                return <MembershipDownload text={currentPopup.text} key={currentPopup.key}
                                           handleClose={this.handleCloseClick}
                                           backdropClick={this.handleCloseClick}
                                           action={currentPopup.action}/>
                break;
            case (popups.CARD_CHECK):
                return <CardCheck text={currentPopup.text} key={currentPopup.key}
                                  handleClose={this.handleCloseClick}
                                  backdropClick={this.handleCloseClick}
                                  benefitId={currentPopup.benefitId}
                                  benefitType={currentPopup.benefitType}/>
                break;
            case(popups.LOGIN):
                return <LoginPopup open={true}
                                      onClose={this.handleCloseClick} 
                                      key={currentPopup.key}
                                      onCloseNotLoggedInUser={currentPopup.onCloseNotLoggedInUser}
                                      redirectPathWhenNotLoggedIn={currentPopup.redirectPathWhenNotLoggedIn}
                                      onLogin={currentPopup.onLogin}
                                      subtitleText={currentPopup.subtitleText}/>
                break;
            case(popups.ACQUIRED):
                return <CopunFlow handleClose={this.handleCloseClick} key={currentPopup.key}
                                  backdropClick={this.handleCloseClick}
                                  benefitId={currentPopup.benefitId}
                                  isAcquired={currentPopup.isAcquired}
                                  purchased={currentPopup.purchased}
                                  action={currentPopup.action}/>
                break;
            case (popups.PAYMENT):
                return <PaymentPopup handleClose={this.handleCloseClick} key={currentPopup.key}
                                     backdropClick={this.handleCloseClick}
                                     benefitId={currentPopup.benefitId}
                                     benefitType={currentPopup.benefitType}
                                     screenHeight={currentPopup.screenHeight}/>
                break;
            case (popups.NEW_PAYMENT):
                return (
                    <NewPaymentPopup
                        key={currentPopup.key}
                        benefit={currentPopup.benefit}
                        benefitId={currentPopup.benefitId}
                        benefitType={currentPopup.benefitType}
                        title={currentPopup.title}
                        image={currentPopup.image}
                        handleClose={this.handleCloseClick}
                    />
                );
            case (popups.DELETE_CARD):
                return <DeleteCard handleClose={this.handleCloseClick} key={currentPopup.key}
                                   backdropClick={this.handleCloseClick}
                                   credit_number={currentPopup.credit_number}
                                   tokenId={currentPopup.tokenId}
                                   holderName={currentPopup.holderName}
                                   zipCode={currentPopup.zipCode}
                                   deleteText={currentPopup.deleteText}
                                   title={currentPopup.title}
                                   action={currentPopup.action}/>
                break;
            case (popups.PHONE_VALIDATION):
                return <PhoneValidationPopup handleClose={this.handleCloseClick} key={currentPopup.key}
                                             backdropClick={this.handleCloseClick}
                                             onCancel={currentPopup.onCancel}
                                             process={currentPopup.process}
                                             data={currentPopup.data}
                                             phone={currentPopup.phone}
                                             action={currentPopup.action}
                                             isEditFlow={currentPopup.isEditFlow}/>
                break;
            case (popups.RADIO_OPTIONS):
                return <RadioOptions handleClose={this.handleCloseClick} key={currentPopup.key}
                                     backdropClick={this.handleCloseClick}
                                     selected={currentPopup.selected}
                                     onChange={currentPopup.onChange}/>
                break;
            case (popups.MAP_VIEW):
                return <MapViewPopup handleClose={this.handleCloseClick} key={currentPopup.key}
                                     backdropClick={this.handleCloseClick}/>
                break;
            case (popups.PURCHASE_APPROVAL):
                return <PurchaseApproval handleClose={this.handleCloseClick} key={currentPopup.key}
                                         backdropClick={this.handleCloseClick}
                                         action={currentPopup.action}
                                         price={currentPopup.price}
                                         phone={currentPopup.phone}/>
                break;

            case(popups.ADD_ADDRESS_POPUP):
                return <AddAddress popup_id={currentPopup.popup_id} key={currentPopup.key}
                                   text={currentPopup.text}
                                   handleClose={this.handleCloseClick}
                                   backdropClick={this.handleCloseClick}
                                   action={currentPopup.action}
                                   btnText={currentPopup.btnText}/>
                break;
            case(popups.ADD_CREDIT_CARD_POPUP):
                return <AddCreditCard popup_id={currentPopup.popup_id} key={currentPopup.key}
                                      text={currentPopup.text}
                                      handleClose={this.handleCloseClick}
                                      backdropClick={this.handleCloseClick}
                                      btnText={currentPopup.btnText}
                                      benefitId={currentPopup.benefitId}
                                      benefitType={currentPopup.benefitType}
                                      cda={currentPopup.cda}
                                      action={currentPopup.action}/>
                break;
            case(popups.CAR_LEAD_FORM_POPUP):
                return <CarLeadFormPopup popup_id={currentPopup.popup_id} key={currentPopup.key}
                                         text={currentPopup.text}
                                         handleClose={this.handleCloseClick}
                                         backdropClick={this.handleCloseClick}
                                         btnText={currentPopup.btnText}
                                         data={currentPopup.data}
                                         isExpert={currentPopup.isExpert}
                                         title={currentPopup.title}
                                         titleBold={currentPopup.titleBold}
                                         screenHeight={currentPopup.screenHeight}/>
                break;
            case(popups.LEAD_PAGE_TERMS_OF_SERVICE):
                return <TermsOfServicePopup
                    key={currentPopup.key}
                    title={currentPopup.title}
                    text={currentPopup.text}
                    handleAccept={currentPopup.handleAccept}
                    handleClose={this.handleCloseClick}
                    backdropClick={this.handleCloseClick}
                />
                break;
            case(popups.VIDEO_ARTICLE):
                return (
                    <VideoArticle
                        key={currentPopup.key}
                        article={currentPopup.article}
                        shouldRedirect={currentPopup.shouldRedirect}
                        buttonText={currentPopup.buttonText}
                        buttonLink={currentPopup.buttonLink}
                        handleClose={this.handleCloseClick}
                    />
                );
                break;
            case(popups.TRAVEL_INSURANCE_POPUP):
                return (
                    <TravelInsurancePopup
                        key={currentPopup.key}
                        data={currentPopup.data}
                        onAgreement={currentPopup.onAgreement}
                        handleClose={this.handleCloseClick}
                    />
                );
                break;
            case(popups.WAIVER_AGREEMENT):
                return (
                    <WaiverAgreementPopup
                        key={currentPopup.key}
                        payload={currentPopup.payload}
                        handleClose={() => this.handleCloseClick()}
                    />
                );
                break;
            case(popups.DATA_SHARING_POPUP):
                return (
                    <UsersConsentsPopup
                        key={currentPopup.key}
                        onAgreement={currentPopup.onAgreement}
                        isShowDataSharingCheckbox={currentPopup.isShowDataSharingCheckbox}
                        isShowMarketingCheckbox={currentPopup.isShowMarketingCheckbox}
                        isShowSubsidyCheckbox={currentPopup.isShowSubsidyCheckbox}
                        rejectConsentOnDismiss={currentPopup.rejectConsentOnDismiss}
                        handleClose={this.handleCloseClick}
                        headerText={currentPopup.headerText}
                        subtitle={currentPopup.subtitle}
                        benefitId={currentPopup.benefitId}
                    />
                );
                break;

        case (popups.IFRAME_POPUP):
            return (
                <IframePopup
                    key={currentPopup.key}
                    handleClose={this.handleCloseClick}
                    iframeUrl={currentPopup.iframeUrl}
                />
            )
        case(popups.DATA_SHARING_SUBSIDY_POPUP):
            return (
                <DataSharingSubsidyPopup
                    key={currentPopup.key}
                    onAgreement={currentPopup.onAgreement}
                    isShowDataSharingCheckbox={currentPopup.isShowDataSharingCheckbox}
                    isShowMarketingCheckbox={currentPopup.isShowMarketingCheckbox}
                    isShowSubsidyCheckbox={currentPopup.isShowSubsidyCheckbox}
                    rejectConsentOnDismiss={currentPopup.rejectConsentOnDismiss}
                    handleClose={this.handleCloseClick}
                    headerText={currentPopup.headerText}
                    subtitle={currentPopup.subtitle}
                    benefitId={currentPopup.benefitId}
                />
            );
            break;
            case(popups.CREATE_FORUM_POST_POPUP):
                return (
                    <CreateForumPostPopup
                        key={currentPopup.key}
                        afterCreation={currentPopup.afterCreation}
                        handleClose={this.handleCloseClick}
                    />
                );
            case(popups.IMAGE_POPUP):
                return (
                    <ImagePopup
                        key={currentPopup.key}
                        image={currentPopup.image}
                        handleClose={this.handleCloseClick}
                    />
                );
            case(popups.REGISTRATION_PHONE_VALIDATION):
                return (
                    <RegistrationPhoneValidation
                        key={currentPopup.key}
                        phone={currentPopup.phone}
                        userId={currentPopup.userId}
                        email={currentPopup.email}
                        ccDigits={currentPopup.ccDigits}
                        registrationPayload={currentPopup.registrationPayload}
                        initialOtpResponse={currentPopup.initialOtpResponse}
                        onLogin={currentPopup.onLogin}
                        handleClose={this.handleCloseClick}
                        process={currentPopup.process}
                    />
                );
            default:
                return (
                    <BasicPopup
                        key={currentPopup.key}
                        text={'Unknown popup type: ' + currentPopup.type}
                        handleClose={this.handleCloseClick}
                    />
                );
        }
    }

    getPopups() {
        const {popupsArray} = this.props;
        return popupsArray?.map((popup) => (
            this.getPopupComponent(popup)
        ));
    }

    render() {
        return (
            <div className="popup">
                {this.getPopups()}
            </div>
        )
    }
}

//connect to Redux store
const mapStateToProps = store => {
    return {
        popupsArray: store.state.popupsArray
    }
}
const mapDispatchToProps = dispatch => {
    return {
        addPopup: (payload) => dispatch(addPopup(payload)),
        removePopup: () => dispatch(removePopup()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(Popups);
